export type MailRequest= {
  fromId: string,
  to: string,
  subject: string,
  text?: string,
  html?: string,
  contentHtml?: {
    method: "GET" | "POST",
    url: string,
    body: {
      renderArgs?: {
        liquid?: any,
      }
    },
    content: string,
  }
}

export class MailApi {
  private static instance: MailApi;

  // Private constructor to prevent direct instantiation
  private constructor() {}

  // Get the Singleton instance
  public static getInstance(): MailApi {
    if (!MailApi.instance) {
      MailApi.instance = new MailApi();
    }
    return MailApi.instance;
  }

  // Method to send the email
  public sendEmail(payload: MailRequest): Promise<any> {

    return fetch("https://mail-v1-1068401357304.us-west1.run.app/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        console.log(JSON.stringify(response));
        if (!response.ok) {
          throw new Error("Failed to send email.");
        }
        return response.json();
      })
      .catch(error => {
        console.log("e:" + JSON.stringify(error));
        throw new Error("Error sending password reset email: " + error.message);
      });
  }
}
